import { createSelector } from '@reduxjs/toolkit';
import { initialState } from './groups_slice';
import { createActionStatusesSelector, createStatusForActionSelector, } from '../../utils/action_statuses_helper';
var getGroupsStore = function (state) { return state.groups || initialState; };
export var getTeamAccountGroups = createSelector(getGroupsStore, function (groupsStore) {
    if (groupsStore) {
        return groupsStore.teamAccountGroups;
    }
    return [];
});
export var getActionStatuses = createActionStatusesSelector(getGroupsStore, initialState);
export var getStatusForAction = createStatusForActionSelector(getActionStatuses);
